// src/api/locResendBatch.ts
//
// Admin batch LOC resend: corrected letters of claim to LENDERS ONLY.
// Backend: python-backend/app/routes/admin_loc_resend_batch.py

import { client } from './claims';

const BASE = '/ui/admin/loc-resend-batch';

export interface LocResendReason {
  reason: string;
  batchKey: string;
  /** 'loc' resends letters of claim; 'withdrawal' resends lender cancellation notices. */
  kind?: 'loc' | 'withdrawal';
  /** Plain words for what the reason sends, e.g. "letters of claim". */
  sends?: string;
  allowedCount: number;
}

export interface LocResendLimits {
  maxChecksPerCall: number;
  maxSendsPerCall: number;
  paceSeconds: number;
}

export type LocResendOutcome =
  | 'would-send'
  | 'sent'
  | 'skipped'
  | 'failed'
  | 'needs-review'
  | 'not-checked'
  | 'not-attempted';

export interface LocResendRow {
  claimId: string;
  outcome: LocResendOutcome;
  lenderName?: string | null;
  recipient?: string | null;
  subject?: string | null;
  agreementNumber?: string | null;
  previousNumber?: string | null;
  skipCode?: string;
  skipReason?: string;
  detail?: string;
  sentAt?: string;
  notifyClient: false;
}

export interface LocResendResponse {
  dryRun: boolean;
  reason: string;
  results: LocResendRow[];
  stopped: boolean;
  limits: LocResendLimits;
}

export const getLocResendReasons = () =>
  client
    .get<{ reasons: LocResendReason[]; limits: LocResendLimits }>(`${BASE}/reasons`)
    .then((res) => res.data);

export const checkLocResend = (reason: string, claimRefs: string[]) =>
  client
    .post<LocResendResponse>(BASE, { reason, claimRefs, dryRun: true }, { timeout: 120000 })
    .then((res) => res.data);

// notifyClient is not sent at all: the server refuses anything but false and
// always resends to the lender only.
export const sendLocResend = (reason: string, claimRefs: string[]) =>
  client
    .post<LocResendResponse>(
      BASE,
      { reason, claimRefs, dryRun: false, confirmCount: claimRefs.length },
      { timeout: 300000 },
    )
    .then((res) => res.data);
